import React, { useEffect, useState } from "react";

// Local static data
const localPortfolio = {
  title: "E-Commerce Website for Fashion Brand",
  description: "Designed and developed a full-featured Shopify store for a luxury fashion label. The goal was to offer a premium experience while ensuring speed, responsiveness, and smooth checkout flows.",
  categories: ["Shopify", "E-Commerce", "Web Development"],
  date: "May 2025",
  task: "Create a scalable and visually stunning online store with custom product pages and seamless integrations.",
  role: ["Design", "Development", "Maintenance"],
  client: "ModaLux",
  categoryYear: "Fashion · 2025",
  liveSite: "https://modalux.store",
  gallery: [
    "/images/portfolio/modalux1.jpg",
    "/images/portfolio/modalux2.jpg",
    "/images/portfolio/modalux3.jpg"
  ]
};

const PortfolioSingleSection = () => {
  const [portfolio, setPortfolio] = useState(null);

  useEffect(() => {
    // Simulate async load
    setTimeout(() => {
      setPortfolio(localPortfolio);
    }, 300); // Optional delay
  }, []);

  if (!portfolio) {
    return <p>Loading...</p>;
  }

  return (
    <section className="content">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-12 col-lg-5">
            <div className="heading">
              <div className="portfolio-meta d-flex align-items-center">
                <div className="portfolio-terms">
                  {portfolio.categories.map((category, index) => (
                    <a key={index} className="terms" href="/portfolio">
                      {category}
                    </a>
                  ))}
                </div>
                <span className="date">{portfolio.date}</span>
              </div>
              <h2>{portfolio.title}</h2>
              <p>{portfolio.description}</p>
            </div>
          </div>
          <div className="col-12 col-lg-6 items portfolio-meta mt-3 mt-md-0">
            <div className="task">
              <h6 className="title mb-3">Task</h6>
              <span className="details">{portfolio.task}</span>
            </div>
            <div className="content item d-flex flex-column flex-md-row justify-content-between">
              <div className="role">
                <h6 className="title mt-0 mb-1 mb-md-3">Role/Services</h6>
                <div className="portfolio-terms">
                  {portfolio.role.map((role, index) => (
                    <a key={index} className="terms" href="/portfolio">
                      {role}
                    </a>
                  ))}
                </div>
              </div>
              <div className="client my-3 my-md-0">
                <h6 className="title mt-0 mb-1 mb-md-3">Client</h6>
                <span>{portfolio.client}</span>
              </div>
              <div className="category">
                <h6 className="title mt-0 mb-1 mb-md-3">Category &amp; Year</h6>
                <span>{portfolio.categoryYear}</span>
              </div>
            </div>
            <div className="socials item">
              <a className="nav-link d-inline-flex swap-icon ms-0" href={portfolio.liveSite}>
                Live Site <i className="icon bi bi-arrow-right-short"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="row portfolio-content items">
          <div className="col-12">
            {portfolio.gallery.map((img, index) => (
              <div key={index} className="item">
                <img src={img} alt={`Gallery ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSingleSection;
